import {
  DISABLE_USER,
  DISABLE_USER_SUCCESSFUL,
  DISABLE_USER_FAILED,
  ENABLE_USER,
  ENABLE_USER_SUCCESSFUL,
  ENABLE_USER_FAILED,
} from "./actionTypes";

export const disableUser = (username, user, token, history) => {
  return {
    type: DISABLE_USER,
    payload: { username, user, token, history },
  };
};

export const disableUserSuccessful = (msg) => {
  return {
    type: DISABLE_USER_SUCCESSFUL,
    payload: msg,
  };
};

export const disableUserFailed = (msg) => {
  return {
    type: DISABLE_USER_FAILED,
    payload: msg,
  };
};

export const enableUser = (username, user, token, history) => {
  return {
    type: ENABLE_USER,
    payload: { username, user, token, history },
  };
};

export const enableUserSuccessful = (msg) => {
  return {
    type: ENABLE_USER_SUCCESSFUL,
    payload: msg,
  };
};

export const enableUserFailed = (msg) => {
  return {
    type: ENABLE_USER_FAILED,
    payload: msg,
  };
};
